<div class="wrap">
  <div class="bg-wrapper">
    <div class="bg-vector" aria-hidden="true" #parallaxBg>
      <img src="/assets/fondo_senora.webp" alt="" />
    </div>
  </div>
  <div class="container">

    <header>
      <button type="button" class="hamburger" aria-label="Menú" (click)="toggleMenu()"
        [attr.aria-expanded]="isMenuOpen">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div class="brand" aria-label="teu">
        <img class="brand-img" src="/assets/logoteu.png" alt="" />
      </div>

      <nav class="nav-pill" aria-label="Navegación" [class.is-open]="isMenuOpen">
        <a href="/cliente">
          <span class="dot"><img src="/assets/logo.png" alt="" /></span>
          Crédito
        </a>
        <div class="separator"></div>
        <a href="/promotor">
          <span class="dot"><img src="/assets/logo.png" alt="" /></span>
          Ser PromoTeur
        </a>
        <!--<a href="#contacto" (click)="isMenuOpen=false">
          <span class="dot"><img src="/assets/logo.png" alt="" /></span>
          Contacto
        </a>-->
      </nav>
    </header>

    <main>
      <section class="copy" #parallaxCopy>
        <h1 class="reveal" #animatedElement>EL CRÉDITO<br />PARA TI.</h1>
        <p class="reveal delay-100" #animatedElement>
          Créditos grupales e <br />individuales,
          <strong>diseñados<br />
            para impulsar tu <br />negocio.</strong>
        </p>

        <button class="cta reveal delay-200" #animatedElement type="button" (mouseenter)="animateOnHover($event)" (click)="goToClientForm()">Pedir mi crédito</button>
      </section>

      <section class="hero-right" aria-label="Imagen principal" #parallaxHero>
        <!-- Imagen solo para mobile -->
        <img src="/assets/fondo_senora-responsive.webp" alt="" class="mobile-img-block" style="display: none" />
        <style>
          @media (max-width: 980px) {
            .hero-right .mobile-img-block {
              display: block !important;
            }
          }
        </style>
      </section>
    </main>
  </div>
  <section class="credito-section" id="credito">
    <div class="credito-inner">
      <div class="credito-head">
        <!-- Usa el mismo ícono del header -->
        <div class="mini-mark">
          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
            <path
              d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
              fill="white" />
            <path
              d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
              fill="#C8E357" />
          </svg>
        </div>

        <div>
          <h2 class="credito-title reveal" #animatedElement>TU CRÉDITO A<br />TU MEDIDA</h2>
          <p class="credito-sub reveal delay-100" #animatedElement>
            Arma tu grupo o solicita el tuyo de manera<br />
            individual. Tú eliges cómo crecer.
          </p>
        </div>
      </div>

      <div class="benefits" role="list">
          <article class="benefit-card reveal" #benefitCard role="listitem">
            <div class="benefit-icon" aria-hidden="true">
              <!-- $ -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M12 1v22" />
                <path d="M17 5.5c0-2-2.2-3.5-5-3.5S7 3.5 7 5.5c0 4 10 2 10 6.5 0 2-2.2 3.5-5 3.5S7 14 7 12" />
              </svg>
            </div>
            <p class="benefit-text">
              CRÉDITOS DE<br /><span class="muted">HASTA $60,000</span>
            </p>
          </article>

          <article class="benefit-card reveal delay-200" #benefitCard role="listitem">
            <div class="benefit-icon" aria-hidden="true">
              <!-- calendario -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="3" />
                <path d="M16 2v4M8 2v4M3 10h18" />
                <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
              </svg>
            </div>
            <p class="benefit-text">
              PAGANDO HASTA<br /><span class="muted">EN 16 SEMANAS</span>
            </p>
          </article>

          <article class="benefit-card reveal delay-400" #benefitCard role="listitem">
            <div class="benefit-icon" aria-hidden="true">
              <!-- flecha tendencia -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M3 17l7-7 4 4 7-7" />
                <path d="M14 7h7v7" />
              </svg>
            </div>
            <p class="benefit-text">
              TASAS DESDE<br /><span class="muted">2.3% SEMANAL</span>
            </p>
          </article>

          <article class="benefit-card reveal delay-500" #benefitCard role="listitem">
            <div class="benefit-icon" aria-hidden="true">
              <!-- refresh -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <path d="M21 12a9 9 0 1 1-3-6.7" />
                <path d="M21 3v6h-6" />
              </svg>
            </div>
            <p class="benefit-text">
              RENOVACIONES<br /><span class="muted">SENCILLAS</span>
            </p>
          </article>
        </div>
    </div>
  </section>

  <section class="grupo-section">
    <div class="grupo-inner">
      <div class="grupo-banner">
        <img src="/assets/img_grupo.webp" alt="" />
        <div class="grupo-banner-card">
          <div class="grupo-banner-card-inner">
            <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
              <path
                d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
                fill="#596AFD" />
              <path
                d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
                fill="#1E1349" />
            </svg>
            <p class="grupo-banner-title reveal" #animatedElement>TU CRÉDITO GRUPAL</p>
            <p class="grupo-banner-sub reveal delay-100" #animatedElement>En 3 pasos:</p>
          </div>
        </div>
      </div>

      <p class="grupo-legend">Cuando nos unimos, todo es posible.</p>

      <div class="grupo-steps">
        <article class="step-card reveal" #stepCard (mouseenter)="animateOnHover($event)">
          <div class="step-number">1</div>
          <p class="step-text">
            Forma tu grupo<br />
            <strong>mínimo 3 integrantes</strong>
          </p>
        </article>

        <article class="step-card reveal delay-200" #stepCard (mouseenter)="animateOnHover($event)">
          <div class="step-number">2</div>
          <p class="step-text">
            Presenten sus<br />
            <strong>documentos básicos</strong>
          </p>
        </article>

        <article class="step-card reveal delay-400" #stepCard (mouseenter)="animateOnHover($event)">
          <div class="step-number">3</div>
          <p class="step-text">
            <strong>24 horas</strong> y tu<br />
            crédito está contigo
          </p>
        </article>
      </div>
    </div>
  </section>

  <section class="simula-credito" id="simula-credito">
    <div class="simula-inner">
      <div class="simula-header-icon reveal" #animatedElement aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 42 42" fill="none">
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#C8E357" />
          <path
            d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
            fill="white" />
        </svg>
        <h2 class="simula-title reveal delay-100" #animatedElement>SIMULA TU CRÉDITO</h2>
      </div>
      <form class="simula-form reveal delay-200" #animatedElement id="simula-form">
        <p class="simula-subtitle">Monto a solicitar:</p>

        <div class="simula-card">
          <input id="simula-monto" class="simula-input" type="text" inputmode="numeric" [ngModel]="simuladorMonto"
            name="simuladorMonto" (focus)="onMontoFocus($event)" (keydown)="onMontoKeyDown($event)" (input)="onMontoInput($event)"
            aria-label="Monto a solicitar" />
        </div>

        <div class="simula-label-card">
          <div class="simula-label-card-header">
            ¿En cuántas semanas quieres pagar?
          </div>
          <div class="simula-label-card-body">
            <select id="simula-semanas" class="simula-select" aria-label="Semanas para pagar"
              [(ngModel)]="simuladorPlazo" name="simuladorPlazo" [disabled]="true">
              @for (plazo of plazos; track plazo.code) {
              <option [value]="plazo.code">
                {{ plazo.name }}
              </option>
              }
            </select>
          </div>
        </div>

        <div class="simula-result-grid">
          <div class="simula-result-card">
            <div class="simula-result-header">
              Pago por semana en el plazo seleccionado:
            </div>
            <div class="simula-result-body" id="simula-pago-semanal">
              {{ pagoSemanalTexto }}
            </div>
          </div>
          <div class="simula-result-card">
            <div class="simula-result-header">
              Monto total a pagar en el plazo seleccionado:
            </div>
            <div class="simula-result-body" id="simula-total-pagar">
              {{ pagoTotalTexto }}
            </div>
          </div>
        </div>

        <a class="simula-cta" href="https://clientes.teu.mx/" target="_blank" rel="noopener noreferrer" (mouseenter)="animateOnHover($event)">
          Solicita tu crédito
        </a>
      </form>
    </div>
  </section>
  <section class="pedir-credito">
    <div class="pedir-inner">

      <div class="social-media-header-icon reveal" #animatedElement aria-hidden="true">
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#596AFD" />
          <path
            d="M0.00273281 20.7993C0.0406484 20.0805 -0.0562474 19.182 0.0574994 18.2923C0.200266 17.1563 0.709265 16.1042 1.50129 15.3081C2.29331 14.5119 3.32151 14.0189 4.41779 13.9095C6.08493 13.7736 7.75973 13.7736 9.42686 13.9095C10.5339 14.0371 11.5649 14.5573 12.3467 15.3825C13.1285 16.2078 13.6133 17.288 13.7198 18.4414C13.8377 20.1777 13.8377 21.9206 13.7198 23.6569C13.5938 24.7761 13.1142 25.8202 12.3563 26.6253C11.5985 27.4304 10.6051 27.951 9.53218 28.1055C8.01977 28.2676 6.49472 28.1449 4.97389 28.1712C4.33408 28.1738 3.70001 28.0457 3.1076 27.7943C2.20408 27.4154 1.42823 26.7674 0.877365 25.9316C0.326503 25.0957 0.0251659 24.1092 0.0111587 23.0959C-0.00147984 22.3903 0.00273281 21.6803 0.00273281 20.7993Z"
            fill="#1E1349" />
        </svg>

        <h2 class="social-media-title reveal delay-100" #animatedElement>¿CÓMO PEDIR MI CRÉDITO?</h2>
      </div>

      <!-- Fondo decorativo -->
      <div class="pedir-bg" aria-hidden="true"></div>

      <div class="pedir-grid">
        <div class="pedir-phoneWrap reveal" #animatedElement></div>

        <div class="pedir-copy reveal delay-200" #animatedElement>
          <p class="pedir-copy-intro">
            Tu crédito, de forma sencilla y con ayuda personalizada.
          </p>

          <ol class="pedir-steps">
            <li>
              <strong>1. Solicitud</strong><br />
              <span>Ten tu identificación oficial vigente y la información de tu
                negocio.</span>
            </li>
            <li>
              <strong>2. Revisión y validación</strong><br />
              <span>Nuestro asesor confirmará tu información y revisaremos tu
                historial crediticio si cuentas con uno.</span>
            </li>
            <li>
              <strong>3. Aprobación, ¡Lista!</strong><br />
              <span>Una vez aprobado, en un plazo de 24 horas abonaremos el monto a
                tu cuenta.</span>
            </li>
          </ol>

          <button class="simula-cta" type="button" (mouseenter)="animateOnHover($event)" (click)="goToClientForm()">Pedir mi crédito</button>
        </div>
      </div>
    </div>
  </section>
  <section class="social-media">
    <div class="social-media-inner">
      <div class="social-media-header-icon reveal" #animatedElement aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 42 42" fill="none">
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#C8E357" />
          <path
            d="M0.00273281 20.7983C0.0406484 20.0796 -0.0562474 19.1811 0.0574994 18.2914C0.200266 17.1553 0.709265 16.1032 1.50129 15.3071C2.29331 14.511 3.32151 14.0179 4.41779 13.9085C6.08493 13.7727 7.75973 13.7727 9.42686 13.9085C10.5339 14.0361 11.5649 14.5563 12.3467 15.3816C13.1285 16.2069 13.6133 17.287 13.7198 18.4404C13.8377 20.1767 13.8377 21.9196 13.7198 23.6559C13.5938 24.7752 13.1142 25.8192 12.3563 26.6243C11.5985 27.4294 10.6051 27.95 9.53218 28.1045C8.01977 28.2667 6.49472 28.1439 4.97389 28.1702C4.33408 28.1728 3.70001 28.0447 3.1076 27.7933C2.20408 27.4144 1.42823 26.7664 0.877365 25.9306C0.326503 25.0947 0.0251659 24.1083 0.0111587 23.0949C-0.00147984 22.3893 0.00273281 21.6793 0.00273281 20.7983Z"
            fill="white" />
        </svg>
        <h2 class="social-media-title reveal delay-100" #animatedElement>COMUNIDAD TEU</h2>
      </div>
    </div>

    <div class="social-media-gallery reveal delay-200" #animatedElement>
      <app-tiktok-carousel title="Últimos TikToks" [items]="tiktoks"></app-tiktok-carousel>
    </div>
  </section>
  <!--<section class="faq" id="faq">
    <div class="faq-inner">
      <div class="faq-header-icon reveal" #animatedElement aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
          <path
            d="M20.8616 42C20.153 42 19.4488 42 18.7402 42C17.4894 41.9683 16.2957 41.4716 15.3933 40.6074C14.4908 39.7431 13.9447 38.5737 13.8621 37.3285C13.7901 35.7225 13.7901 34.1151 13.8621 32.5063C13.9658 30.3817 15.8539 28.3519 18.0186 28.0201C18.3276 27.975 18.6396 27.9534 18.9519 27.9555H22.7886C23.9553 27.9732 25.0911 27.5816 25.9977 26.8491C26.9043 26.1165 27.5241 25.0896 27.7488 23.9477C27.8131 23.643 27.845 23.3325 27.8438 23.0211C27.8438 21.6852 27.8438 20.345 27.8438 19.009C27.8439 17.7563 27.3647 16.5508 26.5039 15.6386C25.6431 14.7264 24.4657 14.1763 23.2121 14.1006C21.7992 14.0101 20.382 14.0402 18.9692 14.0704C17.7519 14.0835 16.5704 13.6598 15.6401 12.8767C14.7098 12.0936 14.0926 11.0031 13.901 9.80402C13.8522 9.46435 13.8291 9.1215 13.8319 8.77837C13.8319 7.42089 13.7887 6.06341 13.8621 4.70593C13.9368 3.57647 14.3904 2.50495 15.1499 1.66383C15.9093 0.822721 16.9304 0.260952 18.0489 0.0689513C18.2941 0.024458 18.5428 0.00138679 18.792 0C20.1876 0 21.5788 0 22.9744 0C24.2848 0.0166749 25.537 0.542401 26.4648 1.46543C27.3927 2.38847 27.9231 3.63603 27.9432 4.94295C27.9432 6.23579 27.9432 7.55879 27.9432 8.86456C27.9039 10.0813 28.3173 11.2696 29.1038 12.2005C29.8904 13.1314 30.9944 13.7391 32.2034 13.9066C32.4496 13.9403 32.6981 13.9548 32.9466 13.9497H36.7876C38.0067 13.9311 39.1921 14.3492 40.1284 15.1281C41.0647 15.907 41.6899 16.995 41.8904 18.1945C41.9228 18.368 41.9402 18.5439 41.9422 18.7203C41.9422 20.4699 42.1237 22.2325 41.8428 23.9692C41.6496 25.011 41.1249 25.963 40.3467 26.6841C39.5685 27.4052 38.578 27.857 37.5222 27.9727C35.997 28.1278 34.4674 28.0072 32.9379 28.0287C32.4489 28.032 31.9623 28.0986 31.4905 28.227C30.4778 28.5329 29.5889 29.152 28.9521 29.9948C28.3152 30.8376 27.9635 31.8604 27.9475 32.9157C27.9475 34.2861 27.9475 35.6522 27.9475 37.0226C27.9376 38.1636 27.5392 39.2674 26.8178 40.153C26.0963 41.0386 25.0946 41.6534 23.9768 41.8966C23.6833 41.9633 23.3834 41.998 23.0824 42H20.8616Z"
            fill="#596AFD" />
          <path
            d="M0.00273281 20.7993C0.0406484 20.0805 -0.0562474 19.182 0.0574994 18.2923C0.200266 17.1563 0.709265 16.1042 1.50129 15.3081C2.29331 14.5119 3.32151 14.0189 4.41779 13.9095C6.08493 13.7736 7.75973 13.7736 9.42686 13.9095C10.5339 14.0371 11.5649 14.5573 12.3467 15.3825C13.1285 16.2078 13.6133 17.288 13.7198 18.4414C13.8377 20.1777 13.8377 21.9206 13.7198 23.6569C13.5938 24.7761 13.1142 25.8202 12.3563 26.6253C11.5985 27.4304 10.6051 27.951 9.53218 28.1055C8.01977 28.2676 6.49472 28.1449 4.97389 28.1712C4.33408 28.1738 3.70001 28.0457 3.1076 27.7943C2.20408 27.4154 1.42823 26.7674 0.877365 25.9316C0.326503 25.0957 0.0251659 24.1092 0.0111587 23.0959C-0.00147984 22.3903 0.00273281 21.6803 0.00273281 20.7993Z"
            fill="#1E1349" />
        </svg>
        <h2 class="faq-title reveal delay-100" #animatedElement>PREGUNTAS <br />FRECUENTES</h2>
      </div>

      <div class="faq-categories">
        @for (category of faqCategories; track category.name; let catIndex = $index) {
        <div class="faq-category reveal" #animatedElement [style.transition-delay]="(catIndex * 100) + 'ms'" [class.is-open]="openCategoryIndex === catIndex">
          <button type="button" class="faq-category-title" (click)="toggleCategory(catIndex)"
            [attr.aria-expanded]="openCategoryIndex === catIndex">
            <span>{{ category.name }}</span>
            <span class="faq-chevron" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.3457 0L15.1084 1.66737L7.55418 8.81325L-3.62396e-05 1.66737L1.76261 0L7.55418 5.47851L13.3457 0Z"
                  fill="#1E1349" />
              </svg>
            </span>
          </button>
          @if (openCategoryIndex === catIndex) {
          <div class="faq-list" role="list">
            @for (item of category.items; track item.question; let itemIndex = $index) {
            <div class="faq-item" role="listitem"
              [class.is-open]="openFaqIndex?.categoryIndex === catIndex && openFaqIndex?.itemIndex === itemIndex">
              <button type="button" class="faq-item-header" (click)="toggleFaq(catIndex, itemIndex)"
                [attr.aria-expanded]="openFaqIndex?.categoryIndex === catIndex && openFaqIndex?.itemIndex === itemIndex">
                <span class="faq-question">{{ item.question }}</span>
                <span class="faq-chevron" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="9" viewBox="0 0 16 9" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M13.3457 0L15.1084 1.66737L7.55418 8.81325L-3.62396e-05 1.66737L1.76261 0L7.55418 5.47851L13.3457 0Z"
                      fill="currentColor" />
                  </svg>
                </span>
              </button>
              @if (openFaqIndex?.categoryIndex === catIndex && openFaqIndex?.itemIndex === itemIndex) {
              <div class="faq-item-body">
                <p>{{ item.answer }}</p>
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
  </section>-->
  <app-footer [colorClass]="footerColorClass"></app-footer>
</div>
